// Canonical display name — rendered as the hero h1
export const siteOwnerName = "Stanton Wortham";

// Canonical title — two lines rendered below h1 in the hero
export const siteOwnerTitle = [
  "Charles F. Donovan, S.J., Dean",
  "Lynch School of Education and Human Development, Boston College",
];

// CV PDF — served from public/vita_26.pdf
// When null, the CV nav link is hidden entirely.
export const cvUrl = "/vita_26.pdf";

// Boston College faculty profile — verified link
export const bcProfileUrl =
  "https://www.bc.edu/bc-web/schools/lynch-school/faculty-research/faculty-directory/stanton-wortham.html";
